import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { login, verifyToken } from "../../lib/api";
import { useToast } from "../../hooks/use-toast";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    (async () => {
      const ok = await verifyToken();
      if (ok) navigate("/admin/dashboard", { replace: true });
      setChecking(false);
    })();
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(password);
      toast({ title: "Welcome back, Tatenda" });
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      toast({ title: "Wrong password", description: "Please try again.", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  if (checking) return <div className="min-h-screen" />;

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#F6F1E8]">
      <button
        onClick={() => navigate("/")}
        className="absolute top-6 left-6 inline-flex items-center gap-2 text-[12px] tracking-[0.2em] uppercase text-[#1A1714]/60 hover:text-[#1A1714]"
      >
        <ArrowLeft size={14} /> Back to site
      </button>
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md bg-[#EFE8DA] border border-[#1A1714]/15 p-10 rounded-sm"
      >
        <div className="flex items-center gap-3 text-[12px] tracking-[0.22em] uppercase text-[#1A1714]/60">
          <Lock size={14} className="text-[#B5523A]" /> Admin access
        </div>
        <h1 className="mt-4 font-serif-display text-4xl tracking-[-0.01em] text-[#1A1714]">
          Edit your portfolio
        </h1>
        <p className="mt-3 text-[#1A1714]/70 text-sm">Enter your password to continue.</p>

        <input
          type="password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="mt-8 w-full bg-transparent border-0 border-b border-[#1A1714]/25 px-0 py-3 focus:outline-none focus:border-[#1A1714] text-xl font-serif-display"
        />
        <button
          type="submit"
          disabled={loading || !password}
          className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#1A1714] text-[#F6F1E8] px-6 py-3 rounded-sm text-[13px] tracking-[0.18em] uppercase hover:bg-[#2c2620] disabled:opacity-60 transition-colors"
        >
          {loading ? "Unlocking…" : "Unlock"}
        </button>
      </form>
    </div>
  );
}
